import makeActionCreator from './makeActionCreator';
import {
  UPDATE_AUTHENTICATION_METHOD,
  UPDATE_AUTHENTICATION_METHOD_DONE,
  UPDATE_AUTHENTICATION_METHOD_ERROR,
  UPDATE_AUTHENTICATION_METHOD_LOADING,
  UPDATE_AUTHENTICATION_METHOD_SUCCESS
} from './actionTypes';

export const updateAuthMethod = makeActionCreator(UPDATE_AUTHENTICATION_METHOD, 'tenantId',
  'method', 'samlUrl', 'samlFile');
export const updateAuthMethodLoading = makeActionCreator(UPDATE_AUTHENTICATION_METHOD_LOADING);
export const updateAuthMethodSuccess = makeActionCreator(UPDATE_AUTHENTICATION_METHOD_SUCCESS,
  'tenant');
export const updateAuthMethodError = makeActionCreator(UPDATE_AUTHENTICATION_METHOD_ERROR, 'error');
export const updateAuthMethodDone = makeActionCreator(UPDATE_AUTHENTICATION_METHOD_DONE);
